import unescapedText from 'I18n/utils/unescapedText';
import { Flex } from 'foundations-components/components/Flex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { HamburgerMenuIcon } from 'foundations-assets/icons/components/HamburgerMenuIcon';
import { useLogo } from '../context/PortalDataContext';
import { MyAccountPopover } from './MyAccountPopover';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PortalsTopBar({
  onHamburgerClick,
  isDrawerOpen,
  headerStart,
  headerEnd
}) {
  var _ref, _logo$alt;
  const logo = useLogo();
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    blockSize: "56px",
    backgroundColor: "fill-surface-recessed",
    flexShrink: "0",
    paddingInline: "200",
    gap: "200",
    "data-test-id": "portals-top-bar",
    children: [/*#__PURE__*/_jsx(Flex, {
      flexShrink: "0",
      alignItems: "center",
      minInlineSize: "0",
      children: logo !== null && logo !== void 0 && logo.src ? /*#__PURE__*/_jsx("img", {
        src: logo.src,
        alt: (_ref = (_logo$alt = logo.alt) !== null && _logo$alt !== void 0 ? _logo$alt : logo.name) !== null && _ref !== void 0 ? _ref : 'Logo',
        style: {
          maxHeight: '32px',
          maxWidth: '120px'
        }
      }) : null
    }), /*#__PURE__*/_jsx(IconButton, {
      onClick: onHamburgerClick,
      "aria-label": unescapedText('app.topBar.openNavigation'),
      "aria-expanded": isDrawerOpen,
      "aria-controls": "portals-nav-drawer",
      tooltip: unescapedText('app.topBar.openNavigation'),
      use: "transparent",
      "data-test-id": "portals-top-bar-hamburger",
      children: /*#__PURE__*/_jsx(HamburgerMenuIcon, {})
    }), headerStart ? /*#__PURE__*/_jsx(Flex, {
      flexShrink: "0",
      alignItems: "center",
      children: headerStart
    }) : null, /*#__PURE__*/_jsx(Flex, {
      flexGrow: "1"
    }), headerEnd ? /*#__PURE__*/_jsx(Flex, {
      flexShrink: "0",
      alignItems: "center",
      children: headerEnd
    }) : null, /*#__PURE__*/_jsx(Flex, {
      flexShrink: "0",
      alignItems: "center",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(MyAccountPopover, {})
    })]
  });
}